<template>
	<div>
		<div class="asd-margin" style="margin-top: 0px;display: flex;justify-content: space-between;align-items: center;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/admin' }">智慧残联</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/admin/onething' }">助残一件事</el-breadcrumb-item>
				<el-breadcrumb-item>
					<span v-if="years.length > 0">{{ thisyear }}</span>年度
					<el-dropdown @command="handleCommand">
						<el-button style="margin:0 0 0 0;padding: 0 0 0 0;" type="text">切换年度</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="p" v-for="(p, i) in years">{{ p }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-breadcrumb-item>

			</el-breadcrumb>
			<div>
				<el-button @click="openw('https://service.cdpf.org.cn/taiji/app/zclXzsp/module/home/home.jsp')"
					type="primary" size="mini" plain>中残联系统</el-button>
				<el-button @click="openw('https://manage.sddpf.org.cn/sdcl_ywjb/welcome.html')" type="primary" size="mini"
					plain>省残联系统</el-button>
			</div>
		</div>
		<div class="asd-margin" style="margin-top: 20px;display: flex;justify-content: space-around;">
			<div class="shaixuanxiang">
				<div class="smallfont" style="margin-right: 5px;">类型:</div>
				<el-select @change="changeTypes" size="small" collapse-tags v-model="selecttypes" multiple
					placeholder="默认为全部">
					<el-option v-for="item in types" :key="item.name" :label="item.name" :value="item.name">
					</el-option>
				</el-select>
			</div>
			<div class="shaixuanxiang">
				<div class="smallfont" style="margin-right: 5px;">状态:</div>
				<el-select style="width: 120px;" @change="changeStatu" size="small" v-model="selectstatus"
					placeholder="默认为全部">
					<el-option v-for="item in status" :key="item.value" :label="item.name" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="shaixuanxiang">
				<div class="smallfont" style="margin-right: 5px;width: 45px;">姓名:</div>
				<el-input style="max-width: 120px;" size="small" v-model="name" placeholder="请输入姓名"></el-input>
			</div>
			<div class="shaixuanxiang" v-if="selecttypes.length==1&&selecttypes.indexOf('儿童康复救助')>=0">
				<div class="smallfont" style="margin-right: 5px;width: 65px;">机构名:</div>
				<el-input style="max-width: 120px;" size="small" v-model="beizhu" placeholder="请输入机构名"></el-input>
			</div>
			<div class="shaixuanxiang" v-if="org.area!='371100000000'">
				<div class="smallfont" style="margin-right: 5px;width: 65px;">手机号:</div>
				<el-input style="max-width: 120px;" size="small" v-model="phone" placeholder="请输入手机号"></el-input>
			</div>
			<div  class="shaixuanxiang" v-else>
				<div class="smallfont" style="margin-right: 5px;">地区:</div>
				<el-select clearable @change="changeTypes1" size="small" collapse-tags v-model="selectareas" 
					placeholder="默认为全部">
					<el-option v-for="item in areas" :key="item.name" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</div>

			<div class="shaixuanxiang">
				<div class="smallfont" style="margin-right: 5px;width: 75px;">身份证号:</div>
				<el-input style="max-width: 140px;" size="small" v-model="idcard" placeholder="请输入身份证号"></el-input>
			</div>
			<div class="shaixuanxiang" style="min-width: 152px;">
				<el-button-group>
					<el-button @click="getonethings(true)" size="mini" type="primary">筛选结果</el-button>
					<el-button size="mini" type="primary" plain>更多</el-button>
				</el-button-group>
			</div>
		</div>
		<div class="asd-margin">
			<el-table size="small" :max-height="gettbheight" :data="onethings" border style="width: 99.5%;">
				<el-table-column prop="id" label="序号" width="40">

				</el-table-column>
				<el-table-column prop="type" label="类型" width="90">
				</el-table-column>
				<el-table-column prop="shixiang" label="事项" width="100">
				</el-table-column>
				<el-table-column prop="show_name" label="申请人姓名" width="90">
				</el-table-column>
				<el-table-column prop="ins_date" label="提交时间">
				</el-table-column>
				<el-table-column prop="phone" label="手机号">
				</el-table-column>
				<el-table-column prop="idcard" label="监护人身份证号">
				</el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						<status :status="scope.row.status"></status>
					</template>
				</el-table-column>
				<el-table-column prop="admin_name" label="审核人"></el-table-column>
				<el-table-column prop="shenhe_date" label="审核时间">
				</el-table-column>
				<!-- <el-table-column prop="kangfu_date" label="康复救助时间">
					
					<template slot-scope="scope">
      <el-date-picker v-model="scope.row.kangfu_date" type="date" placeholder="选择日期" class="rbtn" style="width: 8vw;" @change="handleYearChange"></el-date-picker>
    </template>
					
				</el-table-column> -->
				<el-table-column width="130" label="操作">
					<template slot-scope="scope">
						<el-button @click="showdetail(scope.row)" type="text" size="small">详情</el-button>
						<el-popover style="margin-left: 10px;margin-right: 10px;" placement="top" width="200"
							v-model="scope.row.guidang">
							<div style="margin: 0">
								<el-button @click="changestatus(scope.row, 1, '通过')" size="mini" type="success">通过
								</el-button>
								<el-button @click="changestatus(scope.row, 2, '归档')" size="mini" type="primary">归档
								</el-button>
								<el-button @click="changestatus(scope.row, 3, '驳回')" size="mini" type="danger">驳回
								</el-button>
							</div>
							<el-button slot="reference" type="text" size="small">操作</el-button>
						</el-popover>
						<el-button @click="changestatus(scope.row, -1, '删除')" type="text" style="color: red;"
							size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination @current-change="handleCurrentChange" background :current-page.sync="thispage"
			layout="total,prev, pager, next" :page-size="20" :total="count">
		</el-pagination>
		<onedetail :detail="selectdetail" v-model="detail_show"></onedetail>
	</div>
</template>

<script>
import status from "../components/status.vue"
import onedetail from "../components/onedetail.vue"
export default {
	data() {
		return {
			czload:false,
			thisyear: 2022,
			selectareas:"",
			beizhu:"",
			years: [],
			visible: false,
			name: "",
			phone: "",
			idcard: "",
			selecttypes: [],
			selectstatus: "",
			types: [],
			status: [],
			onethings: [],
			detail_show: false,
			selectdetail: {},
			thispage: 0,
			count: 0,
			areas:[]
		}
	},
	components: {
		status,
		onedetail
	},
	async created() {
		this.getyears();
		await this.gettypes();
		await this.getstatus();
		await this.getonethings(true);
        await this.getarea();
	},
	computed: {
		gettbheight() {

			return window.innerHeight - 280;
		},
		info() {
			let info = window.localStorage.getItem("info");
			return JSON.parse(info);
		},
		org() {
			let org = window.localStorage.getItem("org");
			return JSON.parse(org);
		}
	},
	methods: {
		async getarea(){
             let y = await axios.get(this.$url +"onething/area");
			 this.areas=y.data.lists;
			 console.log(y);
		},
		async handleYearChange(year) {
			this.zdtime = year
		},
		openw(url) {
			window.open(url);
		},
		handleCommand(command) {
			console.log(command);
			this.thisyear = command;
			this.getonethings(true);
		},
		getyears() {
			let endyear = new Date().getFullYear();
			for (var i = endyear; i >= 2021; i--) {
				this.years.push(i);
			};
			this.thisyear = endyear;
		},
		handleCurrentChange(val) {
			this.getonethings(false);
		},
		changeStatu(e) {
			this.getonethings(true);
		},
		async changeTypes(e) {
			this.getonethings(true);
		},
		async changeTypes1(e) {
			this.getonethings(true);
		},
		async changestatus(row, status, tx) {
			    if(this.czload){
					return;
				}else{
					this.czload=true;
				}
				let inputValue = status == 1 ? '同意,已联系申请人' : (status == 2 ? '已归档' : '不同意,已驳回');
				let ans = await this.$prompt(`请输入${tx}意见`, `确实要${tx}${row.show_name}的${row.shixiang}吗?`, {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputValue,
					type: 'warning'
				}).catch(() => {
					row.guidang = false;
					this.czload=false;
				});
				console.log(ans);
				if (!ans) {
					row.guidang = false;
					this.czload=false;
					return;
				};
				console.log(row,'row');
				let y = await axios.post(this.$url + "admin/changestatus", {
					token: this.info.uid,
					status: status,
					id: row.id,
					content: ans.value,
					dept: this.org.name,
					idcard:row.idcard,
					nian:this.thisyear,
					show_name:row.show_name
				});
				this.$message({
					type: 'success',
					message: `${tx}成功!`
				});
				row.guidang = false;
				this.czload=false;
				this.getonethings();
			},
		showdetail(e) {
			this.detail_show = true;
			console.log(e,'eeeeeeeeeee');
			this.selectdetail = e;

		},
		convertDate() {

		},
		async getonethings(clear) {
			if (clear) {
				this.thispage = 0;
			};
			let uptypes = [];
			//处理下权限下的selecttypes
			if (this.info.role.length > 0 && this.info.role[0] != "all") {
				if (this.selecttypes.length == 0) {
					uptypes = this.info.role;
				} else {
					uptypes = this.selecttypes
				}
			} else {
				uptypes = this.selecttypes
			};



			let params = {
				year: this.thisyear,
				token: this.info.uid,
				page: this.thispage == 0 ? 0 : (this.thispage - 1),
				types: uptypes,
				status: this.selectstatus.toString() == ""  ? -1 : this.selectstatus,
				name: this.name,
				phone: this.phone,
				idcard: this.idcard
			};
			// console.log( == "" ? -1 : this.selectstatus,'-----');
			if (this.org.area !== "371100000000") {
				params.area = this.org.area;
			};
			if(this.selectareas!=""){
				params.area = this.selectareas;
			}
			if(this.beizhu!=""&&this.selecttypes.indexOf("儿童康复救助")>=0&&this.selecttypes.length==1){
				params.beizhu=this.beizhu;
			}
			let ans = await axios.get(this.$url + "admin/onething", {
				params: params
			});
            console.log(ans,"最新测试")
			ans.data.lists.map(p => {
				p.show_name = p.child_name ? p.child_name : p.name;
				p.ins_date = new Date(p.ins_date);
				p.ins_date = p.ins_date.toLocaleString();
				if (p.shenhe_date) {
					p.shenhe_date = new Date(p.shenhe_date);
					p.shenhe_date = p.shenhe_date.toLocaleString();
				};
			});
			this.onethings = ans.data.lists;
			console.log(this.onethings,'--------------');
			this.count = ans.data.count;
		},
		async gettypes() {
			let ans = await axios.get(this.$url + "admin/types", {
				params: {
					token: this.info.uid
				}
			});
			if (this.info.role.length > 0 && this.info.role[0] != "all") {
				this.types = ans.data.filter(p => {
					return this.info.role.indexOf(p.name) >= 0;
				});
			} else {
				this.types = ans.data;
			};

		},
		async getstatus() {
			let ans = await axios.get(this.$url + "admin/status", {
				params: {
					token: this.info.uid
				}
			});
			this.status = ans.data;
			console.log(this.status,'0000000000000');
		}
	}
}
</script>

<style>
.asd-margin {
	margin-top: 10px;
	margin-bottom: 10px;
}

.shaixuanxiang {
	display: flex;
	align-items: center;
	margin-right: 20px;
}

.smallfont {
	font-size: 70%;
	min-width: 45px;
}
</style>